import React from 'react';
import { NavLink } from 'react-router-dom';
import Img from '../../../../components/Img'; 
import AppNavbar from '@/AppNavbar';
import { withRouter } from '../../../helpers/withRouter';
import { Translation } from "react-i18next";
import EventbuizzFooter from '../../EventbuizzFooter';
const MasterLayout = ({ children, history, ...rest }) => {
    return (
        <Translation>
            {t => (
                <div id="App" className="inner-pages">
                    <AppNavbar cancel="active" children={children} />
                    <main role="main" className="main-section">
                        <div className="container">
                            <div className="wrapper-box">
                                <div className="top-landing-page">
                                    <div className="row d-flex">
                                        <div className="col-3">
                                            <div className="logo innerpageLogo">
                                                <NavLink to={`/`}>
                                                    <Img alt="Plug'n'Play" width="180" src={require("img/logos.svg")} />
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    {children}
                                </div>
                            </div>
                        </div>
                    </main>
                    <EventbuizzFooter />
                </div>
            )}
        </Translation>
    );
}

class OrganizerLayout extends React.Component {

    render() {
        const { children, ...rest } = this.props;
        return (
            <MasterLayout history={this.props.history}>
                {children}
            </MasterLayout>
        )
    }
};

export default withRouter(OrganizerLayout);